import React from "react";
import { Chip } from "@mui/material";

const STATUS_CONFIG = {
  PROSPECTIVE: { label: "Prospective", color: "warning" },
  Prospective: { label: "Prospective", color: "warning" },
  PENDING: { label: "Pending", color: "warning" },
  Pending: { label: "Pending", color: "warning" },
  VIBRANT: { label: "Vibrant", color: "success" },
  Vibrant: { label: "Vibrant", color: "success" },
  APPROVED: { label: "Approved", color: "success" },
  Approved: { label: "Approved", color: "success" },
  REJECTED: { label: "Rejected", color: "error" },
  Rejected: { label: "Rejected", color: "error" },
};

const VibrancyStatusChip = ({ status }) => {
  const rawStatus = String(status || "Pending");
  const normalized = rawStatus.toUpperCase();
  const config = STATUS_CONFIG[rawStatus] || STATUS_CONFIG[normalized] || {
    label: rawStatus,
    color: "default",
  };

  return (
    <Chip
      size="small"
      label={config.label}
      color={config.color}
      variant="filled"
      sx={{ fontWeight: 700, minWidth: 98 }}
    />
  );
};

export default VibrancyStatusChip;
